import { createSelector } from '@ngrx/store';

import { getRetentionState } from '../retention-feature.selector';

export const getUsageQuestionnaireState = createSelector(
  getRetentionState,
  (state) => state.usageQuestionnaire
);

export const getUsageQuestionnaireFormState = createSelector(
  getUsageQuestionnaireState,
  (state) => state.formState
);
